export default __webpack_public_path__ + "static/media/asistencia.e7231209.png";